const ENV = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    API_KEY: process.env.REACT_APP_API_KEY
}

export default ENV;